import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-grid-radio',
  template: ''
})
export class GridRadioComponent {
  @Input() public action: string;
  @Input() public label: string;
  @Input() public icon: string;
  @Input() public actionsSpanClass = '';
  @Input() public disable: boolean;
  @Input() public isHidden: boolean;
  @Input() public value: string;
}
